import FormBuilder from "@/pages/lead-capture/components/FormBuilder";

export default function NewLeadCaptureFormPage() {
  return <FormBuilder />;
}